/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useEffect, useState} from 'react'
import Chart from 'chart.js/auto'
import {CategoryScale} from 'chart.js'
import JumlahPengguna from '../PieChart/JumlahPengguna'
import {executePost} from '../../../../configs/Kubuku'
import {PENGGUNATERBANYAK} from '../../../../api'

type Props = {
  className?: string
  title?: string
  title2?: string
}

Chart.register(CategoryScale)

const TilesWidget3 = ({
  className,
  title = '10 PERPUSTAKAAN TERATAS',
  title2 = 'BERDASARKAN JUMLAH PENGGUNA',
}: Props) => {
  const [penggunaTerbanyak, setPenggunaTerbanyak] = useState<
    {
      nama: string
      total_pengguna: string
    }[]
  >([])
  const [chartData, setChartData] = useState({
    labels: [] as string[],
    datasets: [
      {
        label: 'User Gained',
        data: [] as string[],
        backgroundColor: [
          'rgba(75,192,192,1)',
          '&quot;#ecf0f1',
          '#50AF95',
          '#f3ba2f',
          '#2a71d0',
          '#A52A2A',
          '#00FFFF',
          '#FF7F50',
          '#FFE4C4',
          '#8A2BE2',
        ],
        borderColor: 'black',
        borderWidth: 2,
      },
    ],
  })

  useEffect(() => {
    const GetDataPenggunaTerbanyak = async () => {
      try {
        const formData = new FormData()
        const response = await executePost(PENGGUNATERBANYAK, formData)
        const dataResponse = response?.data
        setPenggunaTerbanyak(dataResponse)
      } catch (error) {
        console.error('Terjadi kesalahan', error)
      }
    }
    GetDataPenggunaTerbanyak()
  }, [])

  useEffect(() => {
    const labels = penggunaTerbanyak.map((data) => data.nama)
    const dataValues = penggunaTerbanyak.map((data) => data.total_pengguna)

    setChartData((prevChartData) => ({
      ...prevChartData,
      datasets: [
        {
          ...prevChartData.datasets[0],
          data: dataValues,
        },
      ],
      labels: labels,
    }))
  }, [penggunaTerbanyak])

  return (
    <div className={`card ${className}`}>
      {/* begin::Beader */}
      <div className='card-body d-flex flex-column justify-content-between'>
        <h2 className='text-dark fw-bold mb-5 text-center'>
          {title} <br /> {title2}{' '}
        </h2>

        <div className='m-0'>
          <JumlahPengguna chartData={chartData} />
        </div>
      </div>
    </div>
  )
}

export {TilesWidget3}
